import React, { useEffect, useState } from "react";
import Strings from "@my-dld/assets/strings";
import { RVSApi } from "@eres/rvsapi";
import { MollakManagementCompany } from "@eres/rvsapi/entities";
import { SpinnerLoader } from "../SpinnerLoader";
import { LocaleUtil } from "@eres/core";

export function ManagementCompany( props: { tabuPropertyId: number } ) {
	const { tabuPropertyId } = props;
	const [ loading, setLoading ] = useState( false );
	const [ company, setCompany ] = useState<MollakManagementCompany | undefined>( undefined );

	useEffect( () => {
		setLoading( true );
		RVSApi.loadMollakManagementCompany( tabuPropertyId ).then( ( resp: any ) => {
			setLoading( false );
			if ( resp && resp.response && resp.response.items && resp.response.items.length > 0 ) {
				const company: MollakManagementCompany = resp.response.items[ 0 ];
				setCompany( company );
			}
		} ).catch( reason => {
			setLoading( false );
		} );
	}, [ tabuPropertyId ] );

	const phone = company?.phone;
	const mobile = company?.mobile;
	const email = company?.email;
	return <div className="card">
		<div className="card-body">
			{ loading && <div className={ "d-flex " }><SpinnerLoader/></div> }
			{ !loading && company == null && <span>{ Strings.no_data_available }</span> }
			{ !loading && company && <>
				<div className="flex-grid flex-order mb-0">
					<div>
						<span>{ Strings.company_name }</span>
						<span>{ LocaleUtil.getLocalValue( company.company ) }</span>
					</div>
					<div>
						<span>{ Strings.lic_number }</span>
						<span>{ `#${ company.licenseNumber }` }</span>
					</div>
					<div>
						<span>{ Strings.address }</span>
						<span>{ company.address }</span>
					</div>
					<div>
						<span>{ Strings.phone }</span>
						<span>
                        <a href={ `tel:${ phone }` } className="underline">{ phone }</a>
                    </span>
					</div>
					<div>
						<span>{ Strings.Mobile_text }</span>
						<span>
                        <a href={ `tel:${ mobile }` } className="underline">{ mobile }</a>
                    </span>
					</div>
					<div>
						<span>{ Strings.email }</span>
						<span>
                        <a href={ `mailto:${ email }` } className="underline">{ email }</a>
                    </span>
					</div>
				</div>
			</> }
		</div>
	</div>;
}
